// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__VwRA6","col":"CardReaderDesc_col__1kVgw","label":"CardReaderDesc_label__3rwa_"};